import { current } from "@reduxjs/toolkit";
import api from "./api";

const get = () => {
  return api.get("/api/company/get");
};

// const save = (data) => {
//   return api.post("/api/company/save", data);
// };

const update = (company) => {
  return api.post("/api/company/update", company);
};

// The company's wording for Makani's core concepts. Lives on the company's
// settings, not the company record. Reading is auth-only, so a technician gets a
// relabelled app too; writing is company administration.
const getVocabulary = () => {
  return api.get("/api/company/vocabulary");
};

const saveVocabulary = (vocabulary) => {
  return api.post("/api/company/vocabulary", { vocabulary });
};

const CompanyService = {
  get,
  // save,
  update,
  getVocabulary,
  saveVocabulary,
};

export default CompanyService;
